export default "__VITE_ASSET__Tw46jrG4__"